import { Box, Dialog, DialogContent } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { addIdForDataGrid } from "utils"
import { detailColumns } from "./columns"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { branchApiNm } from "branch/constant/branchApiNm"
import DailyJobDialogV3 from "pages/Menu1/DailyJob/DailyJobDialogV3"
import ExpenseDetailDialog from "./ExpenseDetailDialog"
import { deepOrange, green, orange, red } from "@mui/material/colors"

let selectedId = null
let selectedRow = {}

const BasicReportDialog = ({ filter, dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogDailyJobOpen, setDialogDailyJobOpen] = useState(false)
  const [dialogExpenseOpen, setDialogExpenseOpen] = useState(false)

  const modDataTable = useMemo(() => {
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["NumJo", "DrvFixCost", "TripAmnt", "ItmOthOwnRcptAmnt", "InvTransAmnt"
        , "InvOthOwnRcptAmnt", "InvOwnRcptAmnt", "InvCusRcptAmnt", "E1000Amnt", "E88Amnt", "E98Amnt"
        , "InvTotal", "Profit", "ItmCusRcptAmnt"],
      sumColTotal: "DrvNm"
    })
  }, [dataTable])

  const handleCellClick = useCallback(({id, field, row}) => {
    if(field === "ShowDetail"){
      selectedId = id
      setDialogDailyJobOpen(true)
    } else if(field === "ShowDetailExpense"){
      selectedRow = row
      setDialogExpenseOpen(true)
    }
  }, [])
  useEffect(() => {
    if (dialogOpen) {
      ax.post(branchApiNm.getMonthlyTruckReport, filter).then(value => {
        if (value.data) {
          setDataTable(addIdForDataGrid(value.data, "JobOrdId"))
        }
      })
    }

  }, [dialogOpen, ax, filter])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={"รายละเอียด"}
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} >
          <Box height={600} sx={{
            ...sxSumColorClass,
            "& .cell-red": { backgroundColor: red[100] },
            "& .cell-green": { backgroundColor: green[50] },
            "& .cell-greenMore": { backgroundColor: green[100] },
            "& .cell-orange": { backgroundColor: orange[50]},
            "& .cell-deepOrange": { backgroundColor: deepOrange[50]},
          }}>
            <DataGridCellExpand
              hideFooter
              rows={modDataTable}
              columns={detailColumns}
              onCellClick={handleCellClick}
              getRowClassName={getSumColorClassName}
              experimentalFeatures={{ rowPinning: true }}
              pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
            />
          </Box>
        </BoxFC>

        <DailyJobDialogV3
          dialogOpen={dialogDailyJobOpen}
          setDialogOpen={setDialogDailyJobOpen}
          selectedId={selectedId}/>
        <ExpenseDetailDialog 
          dialogOpen={dialogExpenseOpen}
          setDialogOpen={setDialogExpenseOpen}
          selectedRow={selectedRow} />

      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(BasicReportDialog)